// extracted by mini-css-extract-plugin
export default {"Heading":"Transactions_Heading__gUFMN","HeadingBox":"Transactions_HeadingBox__sed0y","HeadingText":"Transactions_HeadingText__7dbA1"};